if (!customElements.get("product-gallery-static")) {
  customElements.define(
    "product-gallery-static",
    class ProductGalleryStatic extends HTMLElement {
      connectedCallback() {
        this.mainImages = this.querySelectorAll("[data-static-main-image]");
        this.mainLinks = this.querySelectorAll("[data-static-main-link]");
        this.thumbsRoot = this.querySelector("[data-static-thumbs]");

        this.thumbsRoot?.addEventListener("click", this.onThumbClick.bind(this));
        this.thumbsRoot?.addEventListener("keydown", this.onThumbKeydown.bind(this));

        const initialId = this.querySelector("[data-static-thumb].is-active")?.dataset
          ?.mediaId;
        if (initialId) {
          this.setActiveMedia(initialId);
        }
      }

      onThumbClick(event) {
        const thumb = event.target.closest("[data-static-thumb]");
        if (!thumb || !this.thumbsRoot?.contains(thumb)) return;
        this.setActiveMedia(thumb.dataset.mediaId);
      }

      onThumbKeydown(event) {
        if (event.key !== "Enter" && event.key !== " ") return;
        const thumb = event.target.closest("[data-static-thumb]");
        if (!thumb) return;
        event.preventDefault();
        this.setActiveMedia(thumb.dataset.mediaId);
      }

      setActiveMedia(mediaId) {
        if (!mediaId) return;
        const id = String(mediaId);

        this.mainImages.forEach((img) => {
          const isActive = img.dataset.mediaId === id;
          img.hidden = !isActive;
          if (isActive) {
            img.removeAttribute("loading");
          }
        });

        this.mainLinks.forEach((link) => {
          const isActive = link.dataset.mediaId === id;
          link.classList.toggle("hidden", !isActive);
          link.setAttribute("tabindex", isActive ? "0" : "-1");
        });

        this.querySelectorAll("[data-static-thumb]").forEach((thumb) => {
          const isActive = thumb.dataset.mediaId === id;
          thumb.classList.toggle("is-active", isActive);
          thumb.setAttribute("aria-current", isActive ? "true" : "false");
        });
      }

      /**
       * Rebuild thumbnails after variant option filtering (from gallery-section).
       * @param {HTMLElement[]} thumbSlides - cloned thumb slide nodes
       * @param {string|number|false} featuredMediaId
       */
      syncFromSlides(thumbSlides, featuredMediaId) {
        if (!this.thumbsRoot) return;

        const visibleIds = [];

        if (thumbSlides?.length) {
          this.thumbsRoot.innerHTML = "";

          thumbSlides.forEach((slide) => {
            const img = slide.querySelector("img");
            if (!img) return;

            const mediaId = img.getAttribute("data-media-id");
            if (!mediaId) return;
            visibleIds.push(mediaId);

            const alt = img.getAttribute("alt") || "";
            const src = img.getAttribute("src") || img.currentSrc;

            const li = document.createElement("li");
            li.className = "wt-product__gallery-static__thumb-item";

            const button = document.createElement("button");
            button.type = "button";
            button.className = "wt-product__gallery-static__thumb";
            button.dataset.staticThumb = "";
            button.dataset.mediaId = mediaId;
            button.setAttribute("aria-label", alt);

            const thumbImg = document.createElement("img");
            thumbImg.src = src;
            thumbImg.alt = alt;
            thumbImg.loading = "lazy";
            thumbImg.width = 200;
            if (img.height) thumbImg.height = img.height;

            button.appendChild(thumbImg);
            li.appendChild(button);
            this.thumbsRoot.appendChild(li);
          });
        }

        this.mainImages.forEach((img) => {
          if (visibleIds.length && !visibleIds.includes(img.dataset.mediaId)) {
            img.hidden = true;
          }
        });

        this.mainLinks.forEach((link) => {
          if (visibleIds.length && !visibleIds.includes(link.dataset.mediaId)) {
            link.classList.add("hidden");
          }
        });

        const activeId =
          featuredMediaId ||
          visibleIds[0] ||
          this.thumbsRoot.querySelector("[data-static-thumb]")?.dataset.mediaId;

        if (activeId) {
          this.setActiveMedia(activeId);
        }
      }
    },
  );
}
